import {
  Button,
  Grid,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import React, { useState, useRef } from "react";
import { useEffect } from "react";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import { Box } from "@mui/system";
import axios from "axios";
import { BranchAction } from "../Store/Branch";
import { useDispatch, useSelector } from "react-redux";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomDateField from "../CustomComponents/CustomDateField";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import dayjs from "dayjs";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import store from "../Store";

const NachExclude = () => {
  //Dispatch
  const dispatch = useDispatch();
  // Loading Branches
  const [branchArray, setBranchArray] = useState([]);
  const [branchValue, setBranchValue] = useState(null);
  const [branchTouch, setBranchTouch] = useState(false);
  const [branchValid, setBranchValid] = useState(false);
  const [branchHasError, setBranchHasError] = useState(false);
  const [uploadBtnDisable, setUploadBtnDisable] = useState(false);
  const currentDate = new Date(dayjs(new Date()).format("MM/DD/YYYY"));

  const [dueDateError, setDueDateError] = useState(false);
  //Success Dialog Message Handler
  const [sucessDialogOpen, setSuccessDialogOpen] = useState(false);
  //Handle Sucess Dialog Message
  const [successDialogMessage, setSuccessDialogMessage] = useState("");
  const [dueDateValidError, setDueDateValidError] = useState(false);
  const handlerSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
    window.location.reload();
  };
  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);
  const [draweeBank, setDraweeBank] = useState("");
  const [draweeBankError, setDraweeBankError] = useState(false);
  const [draweeBankList, setDraweeBankList] = useState([]);
  const [dueDate, setDueDate] = useState("");

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  useEffect(() => {
    const branchValues = GetBranchDetails();
    setBranchArray(branchValues);
    getDraweeBank();
  }, []);
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);
  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };
  let minDateAddValue = Number(0);
  let maxDateAddValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Nach Exclude Request Date Back Count"] &&
        new Date(
          paramValues["Nach Exclude Request Date Back Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Exclude Request Date Back Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateAddValue = 0;
    } else {
      minDateAddValue =
        fieldAccessMap.nachExcludeDate && fieldAccessMap.nachExcludeBackCount
          ? Number(
              paramValues["Nach Exclude Request Date Back Count"]["paramValue"]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["Nach Exclude Request Date Future Count"] &&
        new Date(
          paramValues["Nach Exclude Request Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Exclude Request Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateAddValue = 0;
    } else {
      maxDateAddValue =
        fieldAccessMap.nachExcludeDate && fieldAccessMap.nachExcludeFutureCount
          ? Number(
              paramValues["Nach Exclude Request Date Future Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
  }

  //shortcut key
  const downloadRef = useRef(null);
  const uploadRef = useRef(null);
  const okRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keyup", onKeyPressEventHandler);
    window.addEventListener("keydown", onKeyRemoveEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyRemoveEventHandler);
    };
  }, [dueDate, dispatch]);
  const onKeyRemoveEventHandler = (event) => {
    dispatch(
      CommonShortCutAction.removeDefaultShortCutValue({
        event: event,
        screen: "nachExclude",
      })
    );
  };

  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      okRef: okRef,
      downloadRef: downloadRef,
      uploadRef: uploadRef,
    };
    if (event.ctrlKey) {
      if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        setDueDate(date);
      } else if (charCode === "i") {
        date = new Date();
        setDueDate(date);
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "nachExclude",
          })
        );
      }
    } else if (event.key === "Escape" || event.keyCode === 27) {
      setSuccessDialogOpen(false);
    }
  };
  const getDraweeBank = async () => {
    try {
      const response = await axios.post("/nachExclude/loadDraweeBank", {});
      if (response.data) {
        setDraweeBankList(response.data);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };
  const handleDownload = () => {
    // if (!branchValue || !dueDate || !draweeBank || dueDateValidError) {
    if (!dueDate || !draweeBank || dueDateValidError) {
      // setBranchTouch(true);
      // branchValue ? setBranchHasError(false) : setBranchHasError(true);
      // setBranchValid(false);
      dueDate ? setDueDateError(false) : setDueDateError(true);
      draweeBank ? setDraweeBankError(false) : setDraweeBankError(true);
      // now reset the dialog close.
      let element = document.getElementById("fileUploadInput");
      element.disabled = true;
      setTimeout(function () {
        element.disabled = false;
      }, 1);
    } else {
      setDueDateError(false);
      setDraweeBankError(false);
      // setBranchHasError(false);
      try {
        axios
          .get("/nachExclude/downloadExcel", {
            method: "GET",
            responseType: "blob",
            params: {
              branchValue: "",
              draweeBank: draweeBank,
              dueDate: new Date(dueDate).toLocaleDateString("en-ZA"),
            },
          })
          .then((response) => {
            if (response.status === 206) {
              setMessage("No data to exclude");
              setAlertType("error");
              openAlertHandler();
            } else if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `Nach_Exclude_${new Date().toJSON().slice(0, 10)}.xlsx`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              setMessage("Nach Exclude File Downloaded Success.");
              setAlertType("success");
              openAlertHandler();
            }
          });
      } catch (error) {
        setMessage("Nach Exclude File Downloaded Failed.");
        setAlertType("error");
        openAlertHandler();
        throw Error(error);
      }
    }
  };
  const validateBranch = () => {
    // if (!branchValue || !dueDate || !draweeBank || dueDateValidError) {
    if (!dueDate || !draweeBank || dueDateValidError) {
      // setBranchTouch(true);
      // branchValue ? setBranchHasError(false) : setBranchHasError(true);
      // setBranchValid(false);
      dueDate ? setDueDateError(false) : setDueDateError(true);
      draweeBank ? setDraweeBankError(false) : setDraweeBankError(true);
      // now reset the dialog close.
      let element = document.getElementById("fileUploadInput");
      element.disabled = true;
      setTimeout(function () {
        element.disabled = false;
      }, 1);
    } else {
      // setBranchValid(branchValue !== undefined && branchValue !== "");
      // setBranchTouch(false);
      // setBranchHasError(branchTouch && !branchValid);
      setDueDateError(false);
      setDraweeBankError(false);
    }
  };
  const handleFileUpload = async (event) => {
    setUploadBtnDisable(true);
    try {
      event.preventDefault();
      const file = event.target.files[0];
      if (file.name.includes(".xls")) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("branch", "");
        formData.append("draweeBank", draweeBank);
        formData.append(
          "dueDate",
          new Date(dueDate).toLocaleDateString("en-ZA")
        );
        // now reset the file.
        let element = document.getElementById("fileUploadInput");
        element.value = null;
        const response = await axios.post(
          "/nachExclude/uploadNachExclude",
          formData,
          {
            method: "POST",
            responseType: "blob",
          }
        );
        if (response.status === 200) {
          setSuccessDialogOpen(true);
          setSuccessDialogMessage(
            "Nach Exclude Process Completed Successfully."
          );
          setMessage("Nach Exclude Process Completed Successfully.");
          setAlertType("success");
          //openAlertHandler();
          setUploadBtnDisable(false);
        }
        if (response.status === 206) {
          setMessage(
            "Nach Status is already updated/data mismatch occurs, kindly check once"
          );
          setAlertType("error");
          openAlertHandler();
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Nach_Exclude_ErrorData__${new Date().toJSON().slice(0, 10)}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setUploadBtnDisable(false);
        }
      } else {
        throw new Error("Format not supported");
      }
    } catch (error) {
      setUploadBtnDisable(false);
      if (error.message) {
        setMessage("Invalid file format type");
        setAlertType("error");
        openAlertHandler();
      }
      if (error.response.status === 400 || error.response.status === 500) {
        setMessage("Server Error in processing the uploaded file");
        setAlertType("error");
        openAlertHandler();
      }
      throw Error(error);
    }
  };
  return (
    <>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord-nach-exclude"
          title="Exclude"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          <Box sx={{ marginTop: "-1%" }}>
            <Grid container rowSpacing={0} columnSpacing={2}>
              {/* <Grid item xs={12} md={4}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  required={true}
                  placeholder="Branch"
                  label="Branch"
                  autoCompleteValues={branchArray}
                  value={branchValue}
                  onChange={(event, newValue) => {
                    setBranchValue(newValue);
                    setBranchTouch(newValue ? false : true);
                    setBranchValid(
                      newValue !== undefined &&
                        newValue !== "" &&
                        newValue !== null
                    );
                    setBranchHasError(
                      (newValue ? false : true) &&
                        !(
                          newValue !== undefined &&
                          newValue !== "" &&
                          newValue !== null
                        )
                    );
                    dispatch(BranchAction.updateInitialLoad(false));
                    if (newValue) {
                      dispatch(
                        BranchAction.updateHeaderBranchDetails(newValue.label)
                      );
                    }
                  }}
                />
                {branchHasError && (
                  <p className="error">Please Select Branch</p>
                )}
              </Grid> */}
              <Grid item xs={12} md={4}>
                <CustomAutoComplete
                  type="text"
                  required={true}
                  label="Drawee Bank"
                  variant="standard"
                  value={draweeBank}
                  placeholder="Select Drawee Bank"
                  autoCompleteValues={draweeBankList}
                  onChange={(event, newValue) => {
                    setDraweeBank(newValue);
                    newValue === null
                      ? setDraweeBankError(true)
                      : setDraweeBankError(false);
                  }}
                  disabled={false}
                />
                {draweeBankError && (
                  <p className="error">Please Select Drawee Bank</p>
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomDateField
                  required={true}
                  label="Due Date"
                  disabled={false}
                  id="dueDate"
                  variant="standard"
                  value={dueDate}
                  type="text"
                  maxDate={new Date().setDate(
                    new Date().getDate() + maxDateAddValue
                  )}
                  minDate={new Date().setDate(
                    new Date().getDate() - minDateAddValue
                  )}
                  //maxDate={"2055/12/31"}

                  placeholder="Voucher Date"
                  onChange={(event) => {
                    setDueDate(event ? new Date(event) : null);

                    event === null
                      ? setDueDateError(true)
                      : setDueDateError(false);
                    new Date(event).toDateString() !== "Invalid Date" &&
                    event !== null &&
                    // new Date(event) >= currentDate &&
                    new Date(event).toLocaleDateString().slice(-4) <= "2055"
                      ? setDueDateValidError(false)
                      : setDueDateValidError(true);

                    const maxValue = new Date().setDate(
                      new Date().getDate() + maxDateAddValue
                    );
                    const minValue = new Date().setDate(
                      new Date().getDate() - minDateAddValue
                    );
                    const specialAccessMaxFlag =
                      new Date(event).toLocaleDateString() <=
                      new Date(maxValue).toLocaleDateString();

                    const specialAccessMinFlag =
                      new Date(event).toLocaleDateString() >=
                      new Date(minValue).toLocaleDateString();
                    !specialAccessMaxFlag && !specialAccessMinFlag
                      ? setDueDateValidError(true)
                      : setDueDateValidError(false);
                  }}
                />
                {(dueDateError || dueDateValidError) && (
                  <p className="error">Please Enter Valid Due Date</p>
                )}
              </Grid>
            </Grid>
            <Box
              sx={{
                marginTop: "8px",
                display: "flex",
                marginBottom: "4px",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <Tooltip title="Ctrl+J" placement="top">
                <Button
                  variant="contained"
                  component="label"
                  onClick={handleDownload}
                  sx={{ height: "2rem", fontWeight: "bold" }}
                  ref={downloadRef}
                >
                  Download
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+U" placement="top">
                <Button
                  variant="contained"
                  component="label"
                  disabled={uploadBtnDisable}
                  onClick={validateBranch}
                  ref={uploadRef}
                  sx={{ height: "2rem", fontWeight: "bold" }}
                >
                  Upload
                  <input
                    hidden
                    id="fileUploadInput"
                    accept=".xlsx"
                    type="file"
                    onChange={handleFileUpload}
                  />
                </Button>
              </Tooltip>
            </Box>
            <Dialog
              open={sucessDialogOpen}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>{"Success"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {successDialogMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Tooltip title="Ctrl+K" placement="top">
                  <Button onClick={handlerSuccessDialogClose} ref={okRef}>
                    OK
                  </Button>
                </Tooltip>
              </DialogActions>
            </Dialog>
            <Snackbar
              open={alert}
              autoHideDuration={3000}
              anchorOrigin={{ vertical, horizontal }}
              onClose={closeAlertHandler}
            >
              <Alert
                onClose={closeAlertHandler}
                severity={alertType}
                variant="filled"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
          </Box>
        </AccordianContainer>
      </Box>
      <StlapFooter />
    </>
  );
};
export default NachExclude;
